type SlotEntry = Record<string, unknown> & {
  time?: string | number | null;
  isAvailable?: boolean | null;
};
type SlotCache = Record<string, Record<string, SlotEntry[]>>;
type ScheduleEntry = Record<string, unknown> & { date?: string | null; times?: Array<string | number> };

export function getSlotDetailsForDate(
  slotCache: SlotCache | null | undefined,
  bookingKey: string | null | undefined,
  dateIso: string | null | undefined,
): Array<Record<string, unknown>> | null {
  if (!dateIso || !bookingKey || !slotCache) {
    return null;
  }
  const cacheByBooking = slotCache[bookingKey];
  if (!cacheByBooking) {
    return null;
  }
  const slots = cacheByBooking[dateIso];
  return Array.isArray(slots) ? slots : null;
}

export function resolveSlotInfo(
  slotCache: SlotCache | null | undefined,
  bookingKey: string | null | undefined,
  dateIso: string | null | undefined,
  time: string | null | undefined,
): Record<string, unknown> | null {
  if (!dateIso || !time) {
    return null;
  }
  const slots = getSlotDetailsForDate(slotCache, bookingKey, dateIso);
  if (!Array.isArray(slots)) {
    return null;
  }
  return slots.find((slot) => slot.time === time) || null;
}

export function buildDisplayTimes(
  slotCache: SlotCache | null | undefined,
  bookingKey: string | null | undefined,
  dateIso: string | null | undefined,
  fallbackTimes: unknown[] | null | undefined,
): string[] {
  const slots = getSlotDetailsForDate(slotCache, bookingKey, dateIso);
  if (Array.isArray(slots) && slots.length) {
    return slots
      .filter((slot) => Boolean(slot.isAvailable) && slot.time !== undefined && slot.time !== null)
      .map((slot) => String(slot.time));
  }

  return Array.isArray(fallbackTimes) ? fallbackTimes.map((value) => String(value)) : [];
}

export function getScheduleEntryByDate(
  schedule: ScheduleEntry[] | null | undefined,
  slotCache: SlotCache | null | undefined,
  bookingKey: string | null | undefined,
  dateIso: string | null | undefined,
): ScheduleEntry | null {
  if (!dateIso) {
    return null;
  }

  const entries = Array.isArray(schedule) ? schedule : [];
  const entry = entries.find((item) => item && item.date === dateIso) || null;
  if (!entry) {
    return null;
  }

  const baseTimes = Array.isArray(entry.times) ? entry.times : [];
  return {
    ...entry,
    times: buildDisplayTimes(slotCache, bookingKey, entry.date || null, baseTimes),
  };
}
